// based on http://stackoverflow.com/a/22365674/462087

module.exports = {
    key: "config options just for UI",
    google_maps_api: "https://maps.googleapis.com/maps/api/js?key=AIzaSyC2hJdHmMJd5wNCBRPTjXY1j3oDgyPUteQ&v=3.exp&libraries=geometry,drawing,places",
  }
  


// WEBPACK FOOTER //
// ./config.app.js